module.exports = __webpack_public_path__ + "static/img/learn_more.68adaa28.png";